
export const PATH_TO_PROFILE = "/profile"

export const PATH_TO_GAME = "/game/:gameSlug";
export const linkToGame = (slug) => `/game/${slug}`;

export const PATH_TO_SCOREBOARD = "/game/:gameSlug/scoreBoard/:scoreBoardSlug";
export const linkToScoreBoard = (gameSlug, scoreBoardSlug) => `/game/${gameSlug}/scoreBoard/${scoreBoardSlug}`;